// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3aQzC","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1LuDp"};